export const GTM_ID = 'GTM-NJK6BFC';
export const ACCOUNT_TYPE = 'ECOMMERCE';
export const FB_ID = '';
export const GOOGLE_ADS_ID = 'AW-787744670';
export const GOOGLE_ADS_EVENT_1 = 'AlbzCIr4vLEBEP3am9UC';
export const GOOGLE_CONVERSION_ID = '920696433';
export const GOOGLE_CONVERSION_LABEL = 'lCqECIaX-HMQ8eyCtwM';
export const PINTEREST_ID = '2613517336607';
export const PINTEREST_EMAIL = 'wnetrzavox@gmail.com';
export const RTB_HOUSE_ID = 'U3HwQb3J9tgzXXVr6gc9';
export const TIKTOK_ID = 'C5OMPVLODNNK397VKR60';
export const WP_PIXEL_ID = 'WP-VOX-119HO-DVM';
